// extracted by mini-css-extract-plugin
export default {"filterSubmenu":"FilterSubmenu_filterSubmenu__yNCoK"};